
<div class="content-style-class">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="column">
      <h2 class="titleStyle">{{ titlegrid }}</h2>
    </div>
  </div>
  <div fxLayout="row" class="content-block">
    <div class="dx-card responsive-paddings card-radius">
      <abc-grid
        #companyGrid
        class="grid-group-by-Style"
        [id]="'companyGrid'"
        [noDataText]="noDataText"
        [setupDefaultLayoutOnInitialization]="true"
                [columnChooser]="{ search: {enabled: true}, enabled: true }"

        [height]="'100%'"
        [rowAlternationEnabled]="false"
        [dataSource]="companies"
        [columns]="columnsHeader"
        [allowColumnReordering]="false"
        (onRowRemoved)="(false)"
        (onCellClick)="onCellClick($event)"
        (onCellPrepared)="onCellPrepared($event)"
      >
        <dxo-editing [allowDeleting]="false" [allowAdding]="false"> </dxo-editing>
        <dxo-load-panel [enabled]="true"> </dxo-load-panel>
        <dxo-export [allowExportSelectedData]="false"></dxo-export>
        <dxo-paging [enabled]="false"></dxo-paging>
        <dxo-group-panel #dxGroup [visible]="false"></dxo-group-panel>
        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-search-panel [visible]="true"> </dxo-search-panel>
        <dxo-paging [enabled]="false"></dxo-paging>
      </abc-grid>
      <div *appCheckPermission=" { module: 'Companies', action: Action.CREATE} ">
      <abc-speed-dial-action icon="add" [index]="1" (onClick)="openCompanyDialog()"> </abc-speed-dial-action>
    </div>
  </div>
  </div>

  <abc-popup
    #formCompanyPopup
    class="popup-style"
    [width]="'50%'"
    [height]="'auto'"
    [showCloseButton]="true"
    fxLayout="column"
    fxLayoutAlign="center center"
    (onHiding)="emptyData()"
  >
    <abc-scroll-view class="dx-card popup-card-paddings card-radius" [showScrollbar]="'onScroll'">
      <form action="post" (submit)="onCreateCompany($event)">
        <abc-form #form id="form" [(formData)]="company">
          <dxi-item itemType="group" [colCount]="2">
            <dxi-item [isRequired]="true" class="floating-label">
              <dx-text-box
                dataField="Name"
                name="name"
                labelMode="floating"
                [label]="dataService.res('Ubt-Company-Column-Name') + '*'"
                [(value)]="company.Name"
              >
              </dx-text-box>
            </dxi-item>
            <dxi-item [isRequired]="true" editorType="dxTextBox" class="floating-label">
              <dx-text-box
                dataField="MatchCode"
                name="matchCode"
                labelMode="floating"
                [label]="dataService.res('Ubt-Company-Column-Match-Code') + '*'"
                [(value)]="company.MatchCode"
              >
              </dx-text-box>
            </dxi-item>
          </dxi-item>

          <dxi-item itemType="group" [colCount]="3">
            <dxi-item [isRequired]="true" editorType="dxSelectBox">
              <dx-select-box
                class="drop-down-style"
                [labelMode]="'floating'"
                [(value)]="company.Status"
                displayExpr="Description"
                valueExpr="Value"
                [dataSource]="cachedStatus"
                [label]="dataService.res('Ubt-Company-Column-Status') + '*'"
              >
              </dx-select-box>
            </dxi-item>
            <dxi-item editorType="dxSelectBox">
              <dx-select-box
                class="drop-down-style"
                [(value)]="company.CompanyTitle"
                displayExpr="Description"
                valueExpr="Value"
                [dataSource]="cachedCompaniesTitles"
                [label]="dataService.res('Ubt-Company-Column-Organizations') + '*'"
                [labelMode]="'floating'"
              >
              </dx-select-box>
            </dxi-item>
            <dxi-item class="floating-label">
              <dx-text-box
                mode="number"
                [(value)]="company.CustomerNumber"
                [label]="dataService.res('Ubt-Company-Column-Customer-Number')"
                name="customerNumber"
                labelMode="floating"
              >
              </dx-text-box>
            </dxi-item>
          </dxi-item>

          <dxi-item itemType="group" [colCount]="1">
            <dxi-item [cssClass]="'title-bloc'">
              <p>{{ dataService.res('Ubt-Company-Column-Address') }}</p>
            </dxi-item>
          </dxi-item>

          <dxi-item itemType="group" [colCount]="3">
            <dxi-item class="floating-label">
              <dx-text-box
                dataField="Street"
                name="street"
                labelMode="floating"
                [label]="dataService.res('Ubt-Company-Column-Street')"
                [(value)]="company.Street"
              >
              </dx-text-box>
            </dxi-item>
            <dxi-item class="floating-label">
              <dx-text-box
                [(value)]="company.HouseNumber"
                [label]="dataService.res('Ubt-Company-Column-House-Number')"
                name="houseNumber"
                labelMode="floating"
              >
              </dx-text-box>
            </dxi-item>
            <dxi-item class="floating-label">
              <dx-text-box
                dataField="ZIP"
                name="zip"
                labelMode="floating"
                [label]="dataService.res('Ubt-Company-Column-Zip')"
                [(value)]="company.ZIP"
              >
              </dx-text-box>
            </dxi-item>
          </dxi-item>

          <dxi-item itemType="group" [colCount]="3">
            <dxi-item class="floating-label">
              <dx-text-box
                dataField="City"
                name="city"
                labelMode="floating"
                [label]="dataService.res('Ubt-Company-Column-City')"
                [(value)]="company.City"
              >
              </dx-text-box>
            </dxi-item>
            <dxi-item class="floating-label">
              <dx-text-box
                dataField="Country"
                name="country"
                labelMode="floating"
                [label]="dataService.res('Ubt-Company-Column-Land')"
                [(value)]="company.Country"
              >
              </dx-text-box>
            </dxi-item>
          </dxi-item>

          <dxi-item itemType="group" [colCount]="1">
            <dxi-item [cssClass]="'title-bloc'">
              <p>{{ dataService.res('Ubt-Company-Column-Phone') }}</p>
            </dxi-item>
          </dxi-item>

          <dxi-item itemType="group" [colCount]="4" [cssClass]="'phone-bloc'">
            <dxi-item class="floating-label">
              <dx-text-box
                #phoneTextBox
                [(value)]="phoneNumber.CountryCode"
                [stylingMode]="'outlined'"
                [width]="'100%'"
                [label]="dataService.res('Ubt-Company-Column-Country-Code')"
                mode="number"
                [labelMode]="'floating'"
              >
              </dx-text-box>
            </dxi-item>
            <dxi-item class="floating-label">
              <dx-text-box
                #phoneTextBox
                [(value)]="phoneNumber.LocalAreaCode"
                [stylingMode]="'outlined'"
                [width]="'100%'"
                [label]="dataService.res('Ubt-Company-Column-Local-Area-Code')"
                mode="number"
                [labelMode]="'floating'"
              >
              </dx-text-box>
            </dxi-item>
            <dxi-item class="floating-label">
              <dx-text-box
                #phoneTextBox
                [(value)]="phoneNumber.Number"
                [stylingMode]="'outlined'"
                [width]="'100%'"
                [label]="dataService.res('Ubt-Company-Column-Number')"
                mode="number"
                [labelMode]="'floating'"
              >
              </dx-text-box>
            </dxi-item>
            <dxi-item class="floating-label">
              <dx-text-box
                #phoneTextBox
                [(value)]="phoneNumber.Mediation"
                [stylingMode]="'outlined'"
                [width]="'100%'"
                [label]="dataService.res('Ubt-Company-Column-Extention')"
                mode="number"
                [labelMode]="'floating'"
              >
              </dx-text-box>
            </dxi-item>
          </dxi-item>

          <dxi-item itemType="group" [colCount]="1">
            <dxi-item [cssClass]="'title-bloc'">
              <p>{{ dataService.res('Ubt-Company-Column-Email') }}</p>
            </dxi-item>
          </dxi-item>

          <dxi-item itemType="group" [colCount]="1">
            <dxi-item class="floating-label">
              <dx-text-box
                #emailTextBox
                dataField="EMail"
                name="eMail"
                labelMode="floating"
                type="email"
                [label]="dataService.res('Ubt-Company-Column-Email')"
                [(value)]="email.Value"
              >
              </dx-text-box>
              <dxi-validation-rule type="email"></dxi-validation-rule>
              <!-- <dxi-validation-rule type="required"></dxi-validation-rule> -->
            </dxi-item>
          </dxi-item>

          <dxi-item itemType="group" [cssClass]="'div-buttons'">
            <dxi-item
              itemType="button"
              [cssClass]="'submit-button'"
              [buttonOptions]="{
                useSubmitBehavior: true,
                text:
                  this.companyService.isUpdating === true
                    ? this.dataService.res('Ubt-Company-Icon-Edit')
                    : this.dataService.res('Ubt-Company-Button-Create')
              }"
            >
            </dxi-item>
            <dxi-item
              itemType="button"
              [cssClass]="'cancel-button'"
              [buttonOptions]="{
                text: this.dataService.res('Ubt-Company-Button-Cancel'),
                onClick: cancelButtonOptions.onClick
              }"
            >
            </dxi-item>
          </dxi-item>
        </abc-form>
      </form>
    </abc-scroll-view>
  </abc-popup>

  <abc-popup
    #deleteCompanyPopup
    class="popup-style"
    [width]="'25%'"
    fxLayout="column"
    fxLayoutAlign="center center"
    [height]="'auto'"
    [title]="dataService.res('Ubt-Company-Title-Confirm-Delete')"
    [showCloseButton]="true"
    (onHiding)="emptyData()"
  >
    <div class="dx-card popup-card-paddings card-radius">
      <div class="delete-popup text-center">{{ dataService.res('Ubt-Company-Message-Delete') }}</div>
      <dxi-item itemType="group" fxLayout="row" fxLayoutAlign="center end" fx fxLayoutGap="20px" class="mg-top-20">
        <abc-button
          class="submit-button"
          [text]="dataService.res('Ubt-Company-Icon-Delete')"
          (onClick)="deleteCompany()"
        >
        </abc-button>
        <abc-button
          class="cancel-button"
          [text]="dataService.res('Ubt-Company-Button-Cancel')"
          (onClick)="closePopup()"
        >
        </abc-button>
      </dxi-item>
    </div>
  </abc-popup>
</div>
<abc-context-menu
  #contextMenu
  id="contextMenu"
  class="abc-context-menu"
  showEvent="abcclick"
  [items]="contextMenuItems"
  [position]="{ my: 'top right', at: 'bottom right' }"
>
</abc-context-menu>
